import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { formatQuartzCronLabel } from '@app/pages/admin/orchestration-quartz-cron.util';

@Pipe({
  name: 'quartzCronLabel',
  standalone: true,
  pure: false,
})
export class QuartzCronLabelPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(expression: string | null | undefined): string {
    return formatQuartzCronLabel(expression ?? '', (key, params) => this.translate.instant(key, params));
  }
}
